"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeForumMediaUrl = normalizeForumMediaUrl;
/** Относительный `/static/...` или абсолютный URL вложения форума. */
function normalizeForumMediaUrl(url) {
    if (!url)
        return url;
    if (url.startsWith('//'))
        return `https:${url}`;
    if (url.startsWith('http://')) {
        try {
            const host = new URL(url).hostname.toLowerCase();
            if (host === '4pda.ru' || host === '4pda.to' || host === '4pda.ws' || host.endsWith('.4pda.ru') || host.endsWith('.4pda.to')) {
                return `https://${url.slice('http://'.length)}`;
            }
        }
        catch {
            // keep original
        }
        return url;
    }
    if (url.startsWith('https://'))
        return url;
    if (url.startsWith('/'))
        return `https://4pda.to${url}`;
    return url;
}
